<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="100px"
            class="queryform_div"
          >
            <el-row :gutter="24">
             
              <el-col :md="12" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.Datefrom')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
                <el-button
                  type="primary"
                  @click="getList('search')"
                  size="small"
                >
                  {{ $t("button.query") }}
                </el-button>
                <el-button @click="formselect.queryString = ''" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60px"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="startTime"
                  :label="$t('el.datepicker.startTime')"
                  min-width="120px"
                >
                  <template slot-scope="scope">
                    {{ scope.row.startTime.split("T")[0] }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="endTime"
                  :label="$t('el.datepicker.endTime')"
                  min-width="120px"
                >
                  <template slot-scope="scope">
                    {{ scope.row.endTime.split("T")[0] }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('title.operate')" width="80px">
                  <template slot-scope="scope">
                    <el-button
                      type="default"
                      icon="el-icon-download"
                      circle
                      size="mini"
                      :title="$t('RunningTIme.Download')"
                      v-show="hasDownLoadAuth"
                      @click="downloadPdf(scope.row)"
                    >
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                :current-page.sync="pagination.current"
                :page-size="pagination.pageSize"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                style="text-align: center; margin-top: 10px"
              ></el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>

    <div :id="'pdfDom'" class="pdfDiv">
      <div class="pdfHeader">
        <h4>安装报表-2022年01月01日</h4>
        <img src="~assets/img/IRlogo.png" />
      </div>
      <div class="AssetDiv">
        <div class="block">
          <img src="~assets/img/icon_Shipped.png" />
          <div class="LeftB">
            <h4>客户信息</h4>
            <span class="name">浙江晶科能源有限公司</span>
          </div>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">告警摘要</h4>
          <el-row :gutter="24">
            <el-col :span="8">
              <span class="title">客户资产</span>
              <span class="info">2166372</span>
            </el-col>
            <el-col :span="8">
              <span class="title">警报摘要</span>
              <span class="info">HighIntercoolerCondensate</span>
            </el-col>
            <el-col :span="8">
              <span class="title">告警时间</span>
              <span class="info">2022-02-24</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">服务记录</h4>

          <el-table
            :data="ServiceTable"
            stripe
            style="width: 100%"
            :empty-text="$t('desc.noData')"
          >
            <el-table-column
              label="客户资产"
              min-width="60px"
              prop="AssetsName"
            >
            </el-table-column>
            <el-table-column
              label="服务记录"
              min-width="100px"
              prop="serviceLog"
            >
            </el-table-column>
            <el-table-column
              label="预计服务日期"
              min-width="60px"
              prop="serviceTime"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">运行趋势</h4>
          <div
            class="echarts npPointer"
            style="height: 200px; margin-bottom: 20px"
            id="Line1"
          ></div>

          <div class="echarts npPointer" style="height: 200px" id="Line2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { GetKPIStat, getCustomerRegionTable } from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      formselect:{},
      ServiceTable: [
        { AssetsName: "1593290", serviceLog: "Null", serviceTime: "Null" },
        { AssetsName: "1595220", serviceLog: "Null", serviceTime: "需要维修" },
        {
          AssetsName: "1969309",
          serviceLog: "Null",
          serviceTime: "2022-04-06",
        },
      ],
      Data: [
        52, 32, 78, 47, 61, 29, 45, 76, 98, 10, 21, 35, 90, 68, 57, 43, 14, 35,
        54, 36, 76, 37, 38, 97, 56, 46, 34, 90, 98, 76,
      ],
      TimeData: [
        "2021-04-01",
        "2021-04-02",
        "2021-04-03",
        "2021-04-04",
        "2021-04-05",
        "2021-04-06",
        "2021-04-07",
        "2021-04-08",
        "2021-04-09",
        "2021-04-10",
        "2021-04-11",
        "2021-04-12",
        "2021-04-13",
        "2021-04-14",
        "2021-04-15",
        "2021-04-16",
        "2021-04-17",
        "2021-04-18",
        "2021-04-19",
        "2021-04-20",
        "2021-04-21",
        "2021-04-22",
        "2021-04-23",
        "2021-04-24",
        "2021-04-25",
        "2021-04-26",
        "2021-04-27",
        "2021-04-28",
        "2021-04-29",
        "2021-04-30",
      ],
      RuntimeData: [
        20, 18, 24, 16, 13, 18, 15, 13, 15, 13, 17, 20, 21, 24, 9, 10, 15, 18,
        20, 24, 14, 16, 17, 10, 5, 9, 10, 19, 12, 23,
      ],
    };
  },
  methods: {
    initLine(id, name, unit, TimeData, Data, max) {
      var ActivationLine = this.$echarts.init(document.getElementById(id));

      var optionActivationLine = {
        title: {
          text: name,
          top: 10,
          left: -5,
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 50, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 40,
          left: 35,
          right: 5,
          bottom: 20,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          // boundaryGap: false,
          data: TimeData,
        },
        yAxis: {
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
            formatter: function (value, index) {
              return value + unit;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          max: max,
          min: 0,
        },
        series: [
          {
            name: name,
            type: "line",
            cursor: "default",
            // smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              normal: {
                color: "rgba(255,255,255,1)",
              },
            },
            itemStyle: {
              color: "#00759B",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            emphasis: {
              cursor: "default",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(255,255,255,0.5)" },
                  { offset: 0.9, color: "rgba(255,255,255,0)" },
                  { offset: 1, color: "rgba(255,255,255,0)" },
                ]),
              },
            },
            data: Data,
          },
        ],
      };
      ActivationLine.setOption(optionActivationLine);

      window.addEventListener("resize", () => {
        ActivationLine.resize();
      });
    },
  },
  created() {
    var _self = this;
    this.$nextTick(() => {
      _self.initLine("Line1", "加载率", "%", _self.TimeData, _self.Data, 100);
      _self.initLine(
        "Line2",
        "每日运行时间",
        "h",
        _self.TimeData,
        _self.RuntimeData,
        24
      );
    });
  },
};
</script>


